package com.anjuros.website.templates.template6.styles

import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.anjuros.website.templates.template6.modules.Template6Theme
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba

val CompanyColorVar by StyleVariable<CSSColorValue>()

val Template6NavigationItemStyle = CssStyle {
    base {
        Modifier
            .color(Template6Theme.Primary.rgb)
            .fontWeight(FontWeight.Normal)
            .scale(1.0)
            .transition(Transition.of(property = "color", duration = 200.ms),
                Transition.of(property = "scale", duration = 300.ms))
    }
    hover {
        Modifier
            .color(CompanyColorVar.value())
            .scale(1.1)
            .fontWeight(FontWeight.Bold)
    }
}

val Template6MenuWidthStyle = CssStyle {
    base { Modifier.width(50.percent) }
    Breakpoint.MD {  Modifier.width(25.percent) }
    Breakpoint.LG {Modifier.width(25.percent) }
    Breakpoint.XL { Modifier.width(25.percent)}
}

val Template6HeaderTextStyle = CssStyle {
    base { Modifier.fontSize(24.px).margin(left = 0.px) }
    Breakpoint.MD {  Modifier.fontSize(30.px).margin(left = 0.px) }
    Breakpoint.LG {Modifier.fontSize(36.px).margin(left = 20.px) }
    Breakpoint.XL { Modifier.fontSize(36.px).margin(left = 20.px)}
}

val Template6ReviewPaddingStyle = CssStyle {
    base { Modifier.padding(top=100.px, bottom = 50.px) }
    Breakpoint.MD {  Modifier.padding(topBottom = 100.px) }
    Breakpoint.LG {Modifier.padding(topBottom = 100.px) }
    Breakpoint.XL { Modifier.padding(topBottom = 100.px)}
}

val Template6ReviewsDotStyle = CssStyle {
    base { Modifier .backgroundColor(Colors.Transparent)
        .padding(20.px).
    borderRadius(50.px)}
    Breakpoint.MD {  Modifier.backgroundColor(Colors.Transparent)
        .padding(20.px).
        borderRadius(50.px) }
    Breakpoint.LG {Modifier.backgroundColor(Colors.Transparent)
        .padding(0.px).
        borderRadius(0.px) }
    Breakpoint.XL { Modifier.backgroundColor(Colors.Transparent)
        .padding(0.px).
        borderRadius(0.px)}
}

val Template6CallButton = CssStyle {

    base {
        Modifier
            .transition(Transition.of("all", 300.ms))
    }

    hover {
        Modifier
            .transform { translateY((-4).px) }

    }
}

val Template6LinkFooterContactButton = CssStyle {

    base {
        Modifier
            .color(rgb(185,185,185))
    }

    hover {
        Modifier
            .color(Template6Theme.Secondary.rgb)

    }
}

val Template6LinkContactButton = CssStyle {

    base {
        Modifier
            .color(Colors.White)
    }

    hover {
        Modifier
            .color(Template6Theme.Secondary.rgb)

    }
}

val Template6ReviewStyle = CssStyle {

    Breakpoint.ZERO { Modifier.fillMaxWidth() }
    Breakpoint.SM { Modifier.fillMaxWidth() }
    Breakpoint.MD { Modifier.fillMaxWidth() }
    Breakpoint.LG { Modifier.width(350.px) }
    Breakpoint.XL { Modifier.width(350.px) }
}

val Template6NavigationFooterItemStyle = CssStyle {
    base {
        Modifier
            .fontWeight(FontWeight.Normal)
            .color(rgb(185, 185, 185))
            .scale(1.0f)
            .transition(Transition.of(property = "fontWeight", duration = 200.ms),
                Transition.of(property = "scale", duration = 200.ms))
    }
    hover {
        Modifier
            .fontWeight(FontWeight.Bold)
            .scale(1.1f)
    }
}

val Template6FormWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(80.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(60.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(40.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(40.percent)}
}

val Template6SectionTitleStyle = CssStyle {
    base { Modifier.fontSize(34.px) }
    Breakpoint.MD { Modifier .fontSize(40.px) }
    Breakpoint.LG { Modifier .fontSize(48.px) }
    Breakpoint.XL { Modifier .fontSize(48.px)}
}
val Template6HeroContainerStyle = CssStyle {
    base { Modifier
        .fillMaxWidth(100.percent)  }
    Breakpoint.MD { Modifier
        .fillMaxWidth(100.percent)}
    Breakpoint.LG { Modifier
        .fillMaxWidth(60.percent) .margin(left = 50.px) }
    Breakpoint.XL {Modifier
        .fillMaxWidth(60.percent) .margin(left = 50.px)}
}

val Template6HeroColumnStyle = CssStyle {
    base { Modifier
        .fillMaxWidth(90.percent).alignContent(AlignContent.Center).margin(top = 30.px) }
    Breakpoint.MD { Modifier
        .fillMaxWidth(90.percent).alignContent(AlignContent.Center).margin(top = 30.px)}
    Breakpoint.LG { Modifier
        .width(620.px) }
    Breakpoint.XL {Modifier
        .width(620.px)}
}

val Template6Hero1FontStyle = CssStyle {
    base { Modifier
        .fontSize(42.px)}
    Breakpoint.MD { Modifier
        .fontSize(42.px)}
    Breakpoint.LG { Modifier
        .fontSize(72.px).lineHeight(78.px) }
    Breakpoint.XL {Modifier.fontSize(72.px).lineHeight(78.px)}
}

val Template6Hero2FontStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent)}
    Breakpoint.MD { Modifier.fillMaxWidth(90.percent)}
    Breakpoint.LG { Modifier.width(560.px) }
    Breakpoint.XL {Modifier.width(560.px)}
}

val Template6ReviewBuilderStyle = CssStyle {
    base { Modifier.fillMaxWidth(80.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(90.percent)}
}
